/**
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v4.1.1
 * @link https://github.com/ten1seven/what-input
 * @license MIT
 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("whatInput", [], t) : "object" == typeof exports ? exports.whatInput = t() : e.whatInput = t();
}(this, function () {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;var r = n[o] = { exports: {}, id: o, loaded: !1 };return e[o].call(r.exports, r, r.exports, t), r.loaded = !0, r.exports;
    }var n = {};return t.m = e, t.c = n, t.p = "", t(0);
  }([function (e, t) {
    "use strict";
    e.exports = function () {
      var e = document.documentElement,
          t = "initial",
          n = null,
          o = ["input", "select", "textarea"],
          r = [16, 17, 18, 91, 93],
          i = { keyup: "keyboard", mousedown: "mouse", mousemove: "mouse", MSPointerDown: "pointer", MSPointerMove: "pointer", pointerdown: "pointer", pointermove: "pointer", touchstart: "touch" },
          u = [],
          d = !1,
          s = !1,
          a = { x: null, y: null },
          p = { 2: "touch", 3: "touch", 4: "mouse" },
          c = function () {
        i[y()] = "mouse", f(), v();
      },
          f = function () {
        window.PointerEvent ? (e.addEventListener("pointerdown", m), e.addEventListener("pointermove", w)) : window.MSPointerEvent ? (e.addEventListener("MSPointerDown", m), e.addEventListener("MSPointerMove", w)) : (e.addEventListener("mousedown", m), e.addEventListener("mousemove", w), "ontouchstart" in window && (e.addEventListener("touchstart", h), e.addEventListener("touchend", h))), e.addEventListener(y(), w), e.addEventListener("keydown", m), e.addEventListener("keyup", m);
      },
          m = function (e) {
        if (!d) {
          var u = e.which,
              s = i[e.type];if ("pointer" === s && (s = l(e)), t !== s || n !== s) {
            var a = document.activeElement,
                p = !1;a && a.nodeName && o.indexOf(a.nodeName.toLowerCase()) === -1 && (p = !0), ("touch" === s || "mouse" === s && r.indexOf(u) === -1 || "keyboard" === s && p) && (t = n = s, v());
          }
        }
      },
          v = function () {
        e.setAttribute("data-whatinput", t), e.setAttribute("data-whatintent", t), u.indexOf(t) === -1 && (u.push(t), e.className += " whatinput-types-" + t);
      },
          w = function (t) {
        if (a.x !== t.screenX || a.y !== t.screenY ? (s = !1, a.x = t.screenX, a.y = t.screenY) : s = !0, !d && !s) {
          var o = i[t.type];"pointer" === o && (o = l(t)), n !== o && (n = o, e.setAttribute("data-whatintent", n));
        }
      },
          h = function (e) {
        "touchstart" === e.type ? (d = !1, m(e)) : d = !0;
      },
          l = function (e) {
        return "number" == typeof e.pointerType ? p[e.pointerType] : "pen" === e.pointerType ? "touch" : e.pointerType;
      },
          y = function () {
        var e = void 0;return e = "onwheel" in document.createElement("div") ? "wheel" : void 0 !== document.onmousewheel ? "mousewheel" : "DOMMouseScroll";
      };return "addEventListener" in window && Array.prototype.indexOf && c(), { ask: function (e) {
          return "loose" === e ? n : t;
        }, types: function () {
          return u;
        } };
    }();
  }]);
});